import {createSlice} from '@reduxjs/toolkit';
import {getAccountPageSuccess} from 'src/openapi/admin/apis/AccountInfoApi';
import {getAccountCrmIdSuccess} from 'src/openapi/admin/apis/GetAccountCrmIdApi';
import {getAccountPbIdsSuccess} from 'src/openapi/admin/apis/GetAccountPbIdsApi';

import type {AccountInfo} from 'src/openapi/admin/models/AccountInfo';
import type {CrmId} from 'src/openapi/admin/models/CrmId';
import type {AppState} from 'src/store/typedef';

type InitialState = {
    information: AccountInfo | null,
    crmId: CrmId | null,
    pbIds: Array<string> | null,
};

export const initialState: InitialState = {
    information: null,
    crmId: null,
    pbIds: null,
};

export const accountProfileSlice = createSlice({
    name: 'accountProfile',
    initialState,
    reducers: {
        clearAccountProfileTab: state => {
            state.information = null;
            state.crmId = null;
            state.pbIds = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getAccountPageSuccess, (state, action) => {
                state.information = action.payload.data;
            })
            .addCase(getAccountCrmIdSuccess, (state, action) => {
                state.crmId = action.payload.data;
            })
            .addCase(getAccountPbIdsSuccess, (state, action) => {
                state.pbIds = action.payload.data;
            });
    },
});

export const {clearAccountProfileTab} = accountProfileSlice.actions;

export type SelectAccountInformation = (state: AppState) => AccountInfo | null;
export const selectAccountInformation: SelectAccountInformation = state =>
    state.accountPage.tabs.accountProfile.information;

export type SelectCrmId = (state: AppState) => CrmId | null;
export const selectCrmId: SelectCrmId = state => state.accountPage.tabs.accountProfile.crmId;

export type SelectPbIds = (state: AppState) => Array<string> | null;
export const selectPbIds: SelectPbIds = state => state.accountPage.tabs.accountProfile.pbIds;
